import { render } from "./servicios.vue?vue&type=template&id=4aa6347c&scoped=true"
import script from "./servicios.vue?vue&type=script&lang=js"
export * from "./servicios.vue?vue&type=script&lang=js"

import "./servicios.vue?vue&type=style&index=0&id=4aa6347c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa6347c"]])

export default __exports__